import { useEffect, useRef } from 'react';
import { useLocation, useOutlet } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import PageTransition from '../../components/PageTransition';
import { Navigation } from '../../components/shared/Navigation';
import { TopBar } from '../../components/shared/TopBar';
import config from '../../config';

export function Layout() {
  const location = useLocation();
  const element = useOutlet();

  // /profilemenu открывается выездом справа налево,
  // остальные страницы — «каплей воды» (зум 120% -> 100%)
  const isProfileMenu = location.pathname === config.ROUTES.PROFILE_MENU;
  const prevPathnameRef = useRef(location.pathname);
  const leavingProfileMenu = prevPathnameRef.current === config.ROUTES.PROFILE_MENU && !isProfileMenu;

  useEffect(() => {
    prevPathnameRef.current = location.pathname;
  }, [location.pathname]);

  const custom = { enteringProfileMenu: isProfileMenu, leavingProfileMenu };

  return (
    <div className="flex flex-col justify-start items-center w-[100%] h-[100%]">
      <div className="relative w-full h-full overflow-hidden">
        <AnimatePresence initial={false} custom={custom}>
          <PageTransition key={location.pathname} variant={isProfileMenu ? 'slide' : 'drop'} custom={custom}>
            <TopBar/>
            {element}
          </PageTransition>
        </AnimatePresence>
      </div>
      <Navigation />
    </div>
  );
}
